module.exports = __webpack_public_path__ + "static/header-bottom-805aedaee832cdff5b50091f34c87d60.svg";